import { render, staticRenderFns } from "./EditQuestionsView.vue?vue&type=template&id=4b8183cb&scoped=true"
import script from "./EditQuestionsView.vue?vue&type=script&lang=js"
export * from "./EditQuestionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8183cb",
  null
  
)

export default component.exports